import { render, staticRenderFns } from "./addAffiliateRelation.vue?vue&type=template&id=458ec726"
import script from "./addAffiliateRelation.vue?vue&type=script&lang=js"
export * from "./addAffiliateRelation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports